import Repository from "@shared/services/api/abstracts/Repository";
import { venueBasedUrl } from "@shared/services/api/utils/RepositoryUrlUtils";
import { VenueBaseSegmentSetSerializer } from "../types/seating-types";

export default class VenueBasedSegmentRepository extends Repository<
  Array<VenueBaseSegmentSetSerializer>
> {
  public readonly repositoryName = "VenueBasedSegmentRepository";

  public readonly endpoint = venueBasedUrl("venues/segments/");
}
